import React from 'react';
import styles from './FlowLanding.module.scss';
import { Button } from '../../../components/atoms/Button';
import { ExternalLinkIcon } from '../../../components/atoms/ExternalLinkIcon';
import { useTranslations } from '../../../hooks/useTranslations';
import { useCurrentLanguage } from '../../../hooks/useCurrentLanguage';

interface FlowLandingProps {
  onOrderStart?: () => void;
}

export const FlowLanding: React.FC<FlowLandingProps> = ({ onOrderStart }) => {
  const t = useTranslations();
  const currentLanguage = useCurrentLanguage();

  const handleOrderStart = () => {
    // 注文フロー開始の処理
    if (onOrderStart) {
      onOrderStart();
    }
  };

  const handleUsageGuide = () => {
    // ご利用方法ページへの遷移
  };

  // SPとPCで異なる改行パターンを処理する関数
  const renderDescriptionWithResponsiveBreaks = () => {
    // SP用とPC用の改行パターンを取得
    const spDescription = t.flowLandingDescriptionSp || t.flowLandingDescription;
    const pcDescription = t.flowLandingDescriptionPc || t.flowLandingDescription;

    const renderTextWithBreaks = (text: string, className: string) => {
      return text.split('\n').map((line, index, array) => (
        <React.Fragment key={index}>
          {line}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      ));
    };

    return (
      <>
        {/* SP用テキスト */}
        <span className={styles.descriptionSp}>
          {renderTextWithBreaks(spDescription, styles.descriptionSp)}
        </span>
        
        {/* PC用テキスト */}
        <span className={styles.descriptionPc}>
          {renderTextWithBreaks(pcDescription, styles.descriptionPc)}
        </span>
      </>
    );
  };

  return (
    <div className={styles.container}>
      {/* ヘッダーロゴ */}
      <div className={styles.headerLogo}>
        <picture>
          <source 
            srcSet="https://wakocoffee.myshopify.com/cdn/shop/files/logo2.webp" 
            media="(min-width: 768px)" 
            type="image/webp"
          />
          <img 
            src="https://wakocoffee.myshopify.com/cdn/shop/files/logo2.webp" 
            alt={t.logoAlt}
            width="240"
            height="80"
            loading="eager"
          />
        </picture>
      </div>

      {/* メインコンテンツ */}
      <main className={styles.main}>
        {/* メインテキスト */}
        <div className={styles.mainText}>
          <p className={styles.description}>
            {renderDescriptionWithResponsiveBreaks()}
          </p>
        </div>

        {/* 注意書き */}
        <div className={styles.notice}>
          <p>{t.flowLandingNotice}</p>
        </div>

        {/* 利用方法リンク */}
        <div className={styles.usageGuide}>
          <a 
            href="/pages/how-to-use"
            className={styles.usageLink}
            aria-label={t.flowLanding_usageGuideAriaLabel}
          >
            <span>{t.flowLandingUsageGuideLink}</span>
            <ExternalLinkIcon 
              size={16} 
              className={styles.linkIcon}
            />
          </a>
        </div>

        {/* 注文開始ボタン */}
        <div className={styles.orderStart}>
          <Button
            variant="strong"
            size="large"
            fullWidth
            onClick={handleOrderStart}
          >
            {t.flowLandingOrderStartButton}
          </Button>
        </div>
      </main>
    </div>
  );
};
